import React from "react";

export const InputTextarea = ({label, placeholder, rows, fullHeight, value, change, disabled}) => {
    return (
        <div className={`input-textarea-group ${fullHeight ? 'full-height' : ''}`}>
            {label &&
                <label>{label}</label>
            }
            <textarea disabled={disabled ? disabled : false} rows={rows} placeholder={placeholder ?? ''} onChange={e => change(e.target.value)} value={value} />
        </div>
    );
}

export default InputTextarea;